export const profilePaths = {
  PROFILE: "",
  PROFILE_AVATAR: "avatar",
  PROFILE_USERS_PROFILE_ID: (id) => `users/profiles/${id}`,
  PROFILE_CHANGE_PASSWORD: "password",
};
